<script setup lang="ts">
import type { SiteInfoFragment } from '#gql';

const siteInfo = useNuxtApp().$siteInfo as SiteInfoFragment;
</script>

<template>
  <div class="menu-contact">
    <a class="phone text-lg" :href="`tel:${siteInfo.telephone}`">
      {{ siteInfo.telephone }}
    </a>

    <a class="email text-xs" :href="`mailto:${siteInfo.email}`">
      {{ siteInfo.email }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.menu-contact {
  display: flex;
  flex-direction: column;
}

.menu-contact .phone {
  word-break: break-all;
  text-decoration: none;
}

.menu-contact .email {
  word-break: break-all;
  text-decoration-line: underline;
  text-decoration-color: rgba(9, 89, 139, 0.2);
  text-decoration-thickness: 12%;
  text-underline-offset: 25%;
}
</style>
